import toArray from 'lodash/toArray';
import get from 'lodash/get';

function validateNodeConnections(caseConf, { isEffectChain }) {
  if (isEffectChain) {
    return;
  }
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const errors = [];
  const warnings = [];
  nodes.forEach((node) => {
    if (node.name === 'Action' || node.name === 'Timer') {
      if (!get(node, 'outputs.targets.connections.length')) {
        warnings.push({
          message:
            'Node will have no affect on Sim. It is not connected to other nodes.',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
          metadata: {
            nodeId: node.id,
            scope: 'node',
            defaultVisibility: false,
          },
        });
      }
    } else if (node.name === 'Effect') {
      if (!get(node, 'inputs.inputs.connections.length')) {
        warnings.push({
          message:
            'Node will have no affect on Sim. It is not connected to other nodes.',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
          metadata: {
            nodeId: node.id,
            scope: 'node',
            defaultVisibility: false,
          },
        });
      }
    } else if (node.name === 'Check') {
      if (!get(node, 'inputs.inputs.connections.length')) {
        warnings.push({
          message:
            'Node will have no affect on Sim. It is not connected to other nodes.',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
          metadata: {
            nodeId: node.id,
            scope: 'node',
            defaultVisibility: false,
          },
        });
      }
      if (!get(node, 'outputs.trueOutputs.connections.length') && !get(node, 'outputs.falseOutputs.connections.length')) {
        warnings.push({
          message:
            'Node will have no affect on Sim. It is not connected to other nodes.',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
          metadata: {
            nodeId: node.id,
            scope: 'node',
            defaultVisibility: false,
          },
        });
      }
    }
  });
  return {
    errors,
    warnings,
  };
}

export default validateNodeConnections;
